<div style=" text-align: center; margin-top: 20px;">
    <h2 style="margin-bottom: 25px">Registrations are closed</h2>
    <p>Thank you for your interest in {{ (event ? event.name : '...') }}!</p>
    @if (event?.isEventInThePast()) {
    <p>This event has already taken place.</p>
    } @else if (event?.isNotOpenYet()) {
    <p>Registrations for this event will open on {{event?.registrationOpenDate | date:'dd MMMM yyyy'}}.</p>
    } @else {
    <p>Unfortunately, registrations for this event are currently closed.
        @if (!event?.freeEvent) {
        However, on-site registration with credit card payments will still be possible.
        }
    </p>
    }

    <p>We appreciate your understanding and hope to see you at our future events.</p>
    <p>If you have any questions, do not hesitate to contact the <a href="mailto:{{contactEmail}}">Event
            Manager.</a></p>
</div>